export default (set, selectedOptionName, selectedOptionLabel) => set(
  () => ({
    mobile: {
      selectedOptionName,
      selectedOptionLabel,
    }
  }),
  false,
  { type: 'configurator/updateMobile', selectedOptionName, selectedOptionLabel }
);
